import { useState } from "react";
import { PageHeader } from "../../types/Page";
import { IMAGE_URL } from "../../../path";
import "../../../styles/PageHero.scss";
import { useNavigate } from "react-router-dom";

interface PageHeroProps {
    page?: string;
    headers: PageHeader[];
}

function PageHero({ page, headers }: PageHeroProps) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const navigate = useNavigate();

    function handleNext() {
        setCurrentIndex((prevIndex) =>
            prevIndex === headers.length - 1 ? 0 : prevIndex + 1
        );
    }

    function handlePrevious() {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? headers.length - 1 : prevIndex - 1
        );
    }

    function handleDotClick(index: number) {
        setCurrentIndex(index);
    }

    function handleHeaderClick(header: PageHeader) {
        if (header.link) {
            navigate(header.link);
        }
    }

    if (!headers.length) {
        return null;
    }

    const currentHeader = headers[currentIndex];

    return (
        <div className="page-hero-top">
            <div className="page-hero-track">
                <div
                    key={currentHeader.display_order}
                    className="page-hero-inner active"
                    onClick={() => handleHeaderClick(currentHeader)}
                >
                    <picture>
                        {currentHeader.mobile_image && (
                            <source
                                media="(max-width: 840px)"
                                srcSet={`${IMAGE_URL}/${currentHeader.mobile_image}`}
                            />
                        )}

                        <img
                            src={`${IMAGE_URL}/${currentHeader.image}`}
                            alt="Header"
                        />
                    </picture>

                    <div
                        className={`page-hero-nav ${
                            page === "news" ||
                            page === "contact-us" ||
                            page === "recipes" ||
                            page === "products" ||
                            page === "about-us"
                                ? "active"
                                : ""
                        }`}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="page-hero-arrow"
                            onClick={handlePrevious}
                            aria-label="Previous"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="38"
                                height="38"
                                viewBox="0 0 38 38"
                            >
                                <circle
                                    cx="19"
                                    cy="19"
                                    r="18"
                                    fill="none"
                                    stroke="#fff"
                                    strokeWidth="2"
                                />

                                <path
                                    d="M21.5 11.5L14 19L21.5 26.5"
                                    fill="none"
                                    stroke="#fff"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>

                        <div className="page-hero-dots">
                            {headers.map((header, index) => (
                                <button
                                    type="button"
                                    key={header.display_order}
                                    className={`page-hero-dot ${
                                        index === currentIndex
                                            ? "active"
                                            : ""
                                    }`}
                                    onClick={() => handleDotClick(index)}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>

                        <button
                            type="button"
                            className="page-hero-arrow"
                            onClick={handleNext}
                            aria-label="Next"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="38"
                                height="38"
                                viewBox="0 0 38 38"
                            >
                                <circle
                                    cx="19"
                                    cy="19"
                                    r="18"
                                    fill="none"
                                    stroke="#fff"
                                    strokeWidth="2"
                                />

                                <path
                                    d="M16.5 11.5L24 19L16.5 26.5"
                                    fill="none"
                                    stroke="#fff"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageHero;
